<h3>Reguläre Buttons</h3>
<nz-table #buttonTable [nzData]="buttonList">
	<thead>
		<tr>
			<th>Button</th>
			<th width="200px">Name</th>
			<th width="800px">Beschreibung</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let data of buttonTable.data">
			<td><app-splitbutton [elements]="data.button" [size]="data.size" [noIcon]="data.noIcon" [iconRight]="data.iconRight"></app-splitbutton></td>
			<td>{{data.name}}</td>
			<td>{{data.description}}</td>
		</tr>
		<tr>
			<td>
				<div nz-row [nzGutter]="[16,8]">
					<div nz-col>
						<div *ngTemplateOutlet="workflowViewModeSelection"></div>
					</div>
					<div nz-col nzSpan="11">
						<app-splitbutton [elements]="workflowStartedContinueSplitButton" [noIcon]="true" size="large" [block]="true"></app-splitbutton>
					</div>
				</div>
			</td>
			<td>Workflowschritt Modus auswählen und starten/anzeigen/fortsetzen</td>
			<td>Erlaubt die Auswahl des Ansichtsmodus über die Radiobuttons, sowie die Option die Übersicht innerhalb des Burgermenüs zu betreten (wenn
				vorhanden). Ansonsten lässt sich die Bearbeitung des Workflowschritts fortsetzen oder nach Beendigung die Übersicht (wenn vorhanden) über
				den Primärbutton anzuzeigen. Innerhalb des Burgermenüs lassen sich ebenfalls die Eingaben des Workflowschritts zurücksetzen</td>
		</tr>
	</tbody>
</nz-table>
<h3>Ablenkungsfreier Wizard Buttons</h3>
<nz-table #buttonTable [nzData]="buttonList">
	<thead>
		<tr>
			<th>Button</th>
			<th>Name</th>
			<th>Beschreibung</th>
		</tr>
	</thead>
	<tbody>
		<tr>
			<td>
				<button nz-button nzType="secondary" type="button" class="big-back-button">
					<i nz-icon nzType="close"></i>
				</button>
			</td>
			<td>Schließen</td>
			<td>Schließt den 'Ablenkungsfreien Wizard' (nur wenn die Detailseite nicht existiert).</td>
		</tr>
		<tr>
			<td>
				<button nz-button nzType="secondary" type="button" class="big-back-button">
					<i nz-icon nzType="close"></i>
				</button>
			</td>
			<td>z. Detailseite</td>
			<td>Navigiert zur Fragebogen-Übersichtseite (nur wenn diese existiert).</td>
		</tr>
		<tr>
			<td>
				<button nz-button nzType="primary" class="big-button"><i nz-icon nzType="left"></i>
					{{ 'actions.back' | translate }}
				</button>
			</td>
			<td>Zurück</td>
			<td>Navigiert zur letzten Seite des Workflowschritts im Ablenkungsfreien Wizard.</td>
		</tr>
		<tr>
			<td>
				<button nz-button nzType="primary" class="big-button">
					{{ 'actions.next' | translate }}<i nz-icon nzType="right"></i>
				</button>
			</td>
			<td>Weiter</td>
			<td>Navigiert zur nächsten Seite des Workflowschritts im Ablenkungsfreien Wizard.</td>
		</tr>
		<tr>
			<td>
				<button nz-button nzType="primary" class="big-button">
					<i nz-icon nzType="check"></i>{{ 'workflow.end' | translate }}
				</button>
			</td>
			<td>Beenden</td>
			<td>Schließt den Workflowschritt ab und navigiert zur Workflowschrittdetailseite.</td>
		</tr>
		<tr>
			<td>
				<button nz-button nzType="primary" class="big-button">
					{{ 'actions.next_question_group' | translate }}<i nz-icon nzType="right"></i>
				</button>
			</td>
			<td>Nächster Test</td>
			<td>Signalisiert das Ende der derzeitigen Fragegruppe und beginnt die nächste.
				Erst nach der gültigen Bearbeitung der Fragegruppe aktiv
				(alle obligatorischen Fragen der Gruppe haben einen Wert).</td>
		</tr>
	</tbody>
</nz-table>

<ng-template #workflowViewModeSelection>
	<nz-radio-group [(ngModel)]="selectedViewMode" nzSize="large" (ngModelChange)="initSplitButtons()" class="round-radio-button-wrapper">
		<label nz-radio-button nzValue="wizard">
			<i-feather class="icon" [name]="distractionFreeWizardIcon"></i-feather>
			{{ 'workflow.distractionfreeWizard' | translate }}
		</label>
		<label nz-radio-button nzValue="compact">
			<i-feather class="icon" [name]="compactViewIcon"></i-feather>
			{{ 'workflow.compactView' | translate }}
		</label>
	</nz-radio-group>
</ng-template>
